(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("layered-dark", [], factory);
	else if(typeof exports === 'object')
		exports["layered-dark"] = factory();
	else
		root["SurveyTheme"] = root["SurveyTheme"] || {}, root["SurveyTheme"]["LayeredDark"] = factory();
})(this, () => {
return 